import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ListaPromocaoResponse } from '../../responses/scanntech/lista-promocao.response';
import { StatusPromocaoScanntechEnum } from '../../../enums/scanntech/status-promocao-scanntech.enum';

@Injectable({
  providedIn: 'root',
})
export class PromocaoService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public getListaPromocoes(idStatus: StatusPromocaoScanntechEnum): Observable<ListaPromocaoResponse> {
    return this.httpClient
      .get<ListaPromocaoResponse>(
        environment.urlApiScanntech + `Promocao/listaPromocoes/idStatus/${idStatus}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
